import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const InfoCircleLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M12 22.9102C17.5228 22.9102 22 18.433 22 12.9102C22 7.38731 17.5228 2.91016 12 2.91016C6.47715 2.91016 2 7.38731 2 12.9102C2 18.433 6.47715 22.9102 12 22.9102Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M11.99 8.2002H12.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M13.46 17.6202L13 17.5002C12.4 17.3502 11.98 16.8102 11.98 16.1902V12.3502C11.98 11.7102 11.53 11.1502 10.89 11.0202L10.54 10.9502"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="none" transform="translate(0 0.910156)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
